export default __webpack_public_path__ + "static/media/K2D-Regular.a8691725.ttf";